export const CONSTANTS = {
  "IMG_PLACEHOLDER_VIDEO": "http://via.placeholder.com/350x300"
}
